import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import About from "./About";
import { Link } from "react-router-dom";
import FirstPage from "./firstPage";
import logo from "../assets/images/SmartSpendLogo.svg";
import Features from "./Features";
import Screenshot from "./screenshot";
import Download from "./download";
import Footer from "./Footer";
import Contact from "./contact";
import { IoMenu, IoClose } from "react-icons/io5";
import HelpCenter from "./HelpCenter";

const Home = () => {
  const aboutRef = useRef(null);
  const featuresRef = useRef(null);
  const screenshotsRef = useRef(null);
  const contactUsRef = useRef(null);
  const sidebarRef = useRef(null);
  const headerRef = useRef(null);

  const [showSidebar, setShowSidebar] = useState(false);
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(false);

  const scrollToSection = (sectionRef) => {
    if (sectionRef.current) {
      const largeScreenOffset = 5;
      const mobileScreenOffset = 90;
      const offset = isLargeScreen ? largeScreenOffset : mobileScreenOffset;

      const sectionTop = sectionRef.current.offsetTop - offset;

      window.scrollTo({
        top: sectionTop,
        behavior: "smooth",
      });

      setShowSidebar(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleScroll = () => {
    if (headerRef.current) {
      if (window.scrollY > 200) {
        headerRef.current.classList.add("shadow-lg");
      } else {
        headerRef.current.classList.remove("shadow-lg");
      }
    }

    if (window.scrollY > 200) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setShowSidebar(false);
    }
  };

  useEffect(() => {
    if (showSidebar) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSidebar]);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      setIsLargeScreen(width >= 768);
    };

    handleResize();

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div className="px-8 lg:px-8 xl:px-52 bg-white">
        <header
          ref={headerRef}
          className={`text-black z-10 bg-white ${
            isLargeScreen ? "static" : "fixed top-0 left-0 right-0 w-full"
          }`}
          style={{ width: "100%" }}
        >
          <div className="container mx-auto flex items-center justify-between h-[70px]">
            <Link to="/" className="flex items-center justify-center mb-4 ">
              <img src={logo} alt="Icon" className="mt-2 w-48" />
            </Link>

            <div className="md:hidden flex items-center">
              <button onClick={() => setShowSidebar(true)}>
                <IoMenu size={30} className="text-black" />
              </button>
            </div>
            <nav className="hidden md:flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-8 font-semibold">
              <button
                onClick={() => scrollToSection(aboutRef)}
                className="hover:text-[#1380E7] text-sm sm:text-base md:text-sm lg:text-base"
              >
                About
              </button>
              <button
                onClick={() => scrollToSection(featuresRef)}
                className="hover:text-[#1380E7] text-sm sm:text-base md:text-sm lg:text-base"
              >
                Features
              </button>
              <button
                onClick={() => scrollToSection(screenshotsRef)}
                className="hover:text-[#1380E7] text-sm sm:text-base md:text-sm lg:text-base"
              >
                Screenshots
              </button>
              <button
                onClick={() => scrollToSection(contactUsRef)}
                className="hover:text-[#1380E7] z-10 text-sm sm:text-base md:text-sm lg:text-base"
              >
                Contact Us
              </button>
              <Link
                to="/privacy-policy"
                className="hover:text-[#1380E7] z-10 text-sm sm:text-base md:text-sm lg:text-base"
              >
                Privacy Policy
              </Link>
            </nav>
          </div>
        </header>

        {showSidebar && (
          <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
            <div
              ref={sidebarRef}
              className="fixed top-0 right-0 h-full bg-white shadow-lg p-4"
              style={{ width: "300px" }}
            >
              <button
                onClick={() => setShowSidebar(false)}
                className="absolute top-4 right-4"
              >
                <IoClose size={30} className="text-black" />
              </button>

              {/* Sidebar Menu */}
              <nav className="flex flex-col space-y-4 mt-10">
                <button
                  className="text-lg font-semibold hover:text-[#1380E7] text-left border-b border-gray-300 pb-2"
                  onClick={() => scrollToSection(aboutRef)}
                >
                  About
                </button>
                <button
                  className="text-lg font-semibold hover:text-[#
                  ] text-left border-b border-gray-300 pb-2"
                  onClick={() => scrollToSection(featuresRef)}
                >
                  Features
                </button>
                <button
                  className="text-lg font-semibold hover:text-[#1380E7] text-left border-b border-gray-300 pb-2"
                  onClick={() => scrollToSection(screenshotsRef)}
                >
                  Screenshots
                </button>
                <button
                  className="text-lg font-semibold hover:text-[#1380E7] text-left border-b border-gray-300 pb-2"
                  onClick={() => scrollToSection(contactUsRef)}
                >
                  Contact Us
                </button>
                <NavLink
                  to="./privacy-policy"
                  className="text-lg font-semibold hover:text-[#1380E7] text-left border-b border-gray-300 pb-2"
                  onClick={() => setShowSidebar(false)}
                >
                  Privacy Policy
                </NavLink>
              </nav>
            </div>
          </div>
        )}
        <FirstPage />
      </div>

      <div ref={aboutRef} className="bg-[#eeeeee] -mt-[65px] about-class ">
        <About />
      </div>
      <div ref={featuresRef} id="features">
        <Features />
      </div>
      <div ref={screenshotsRef} id="screenshots" className="bg-[#eeeeee]">
        <Screenshot />
      </div>
      <div id="helpcenter">
        <HelpCenter contactUsRef={contactUsRef} />
      </div>
      <div className="bg-cover bg-center">
        <Download />
      </div>
      <div ref={contactUsRef} id="contact">
        <Contact />
      </div>
      <div className="bg-[#eeeeee]">
        <Footer />
      </div>

      {/* Scroll to Top */}
      {showScrollToTop && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-5 right-5 bg-gray-800 text-white px-3 py-2 rounded-full"
        >
          ↑
        </button>
      )}
    </>
  );
};

export default Home;
